import {useMemo, useState} from "react"
import {useReviewMediaVariables} from "./useReviewMediaVariables";
import {useSuspenseQuery} from "@apollo/client";
import {MediaModel} from "../models/view/mediaModel";
import {ReviewMediaModel} from "../models/domain/reviewMediaModel";
import {contentService} from "../api/contentService";
import {ReviewMediaType} from "../definitions/types";

export const useReviewMediaQuery = () => {
    const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
    const {variables} = useReviewMediaVariables();

    const {error, data} = useSuspenseQuery(contentService.media.connection.query, {
        errorPolicy: "none",
        variables
    });

    // Destructure both reviewMedia and primaryReviewMedia from the userContent object.
    const {reviewMedia, primaryReviewMedia} = data?.userContent ?? {
        reviewMedia: undefined,
        primaryReviewMedia: undefined
    };

    // Create a connection object from the coalition of the primaryReviewMedia and reviewMedia objects
    // or create a default connection object.
    const connection = primaryReviewMedia?.connection ?? reviewMedia?.connection ?? {
        media: [] as ReviewMediaType[],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: false
        }
    }

    const model = new MediaModel(connection);

    const {medium, media} = useMemo(() => {
        if (error || activeIndex === undefined || model.visibleMedia.length === 0) return {
            medium: undefined,
            media: [] as ReviewMediaModel[]
        };
        const medium = model.visibleMedia[activeIndex];
        const media = model.visibleMedia.filter((reviewMediaModel) => reviewMediaModel.reviewId === medium.reviewId);
        return {medium, media};
    }, [error, model, activeIndex]);

    return {
        model,
        activeMedium: {
            activeIndex,
            setActiveIndex,
            medium,
            hasMedia: media.length > 0,
            media
        },
        modal: {
            header: `Customer Photos (${(activeIndex ?? 0) + 1} of ${model.visibleMedia.length})`
        },
        error: error?.message
    }
}